export default {
  data() {
    return {
      button: document.querySelector(
        "#header-apply"
      )
    };
  },
  methods: {
    set_header_apply_term(termID) {
      // ManageApply.js does not manage header button so do it here:
      console.log(`set_header_apply_term ${termID}`);
      const button = document.querySelector("#header-apply");
      if (!button) return;

      const url = new URL(button.href);
      const params = new URLSearchParams(url.search);

      params.delete("Term");
      params.append("Term", termID);

      url.search = params.toString();
      button.href = url.toString(); 
    },
  }
};
